module.exports = __webpack_public_path__ + "static/media/heart4.22115e33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/heart4.svg
// module id = 3023
// module chunks = 7